export default "__VITE_ASSET__DKO5Tsaw__"